import {
  verifyToken,
  change,
  setPassword,
  resetSubmittedChangeState,
  resetErrorMessage,
  resetState,
} from "../../../modules/recovery";
import {
  setOpenAuthModal,
  closeModalGoHome,
  onAuthModalClose,
  decrypt,
  setModalTitle,
} from "../../../modules/login";

// Acessors
const getAccountUsername = (state) => decrypt(state?.loginReducer.username);
const getPasswordToken = (state) => state?.loginReducer.passwordToken;
const getAcceptedTerms = (state) =>
  state?.loginReducer.acceptedTermsAndConditions;
const getSubmittedChange = (state) => state?.recoveryReducer.submittedChange;
const getIsTokenValid = (state) => state?.recoveryReducer.isTokenValid;
const getErrorMessage = (state) => state?.recoveryReducer.errorMessage;

const initialState = {};

export const passwordDefineReducer = (state = initialState, action) => {
  return state;
};

export const mapStateToProps = (state) => {
  return {
    accountUsername: getAccountUsername(state),
    passwordToken: getPasswordToken(state),
    acceptedTermsAndConditions: getAcceptedTerms(state),
    submittedChange: getSubmittedChange(state),
    isTokenValid: getIsTokenValid(state),
    errorMessage: getErrorMessage(state),
  };
};

export const mapDispatchToProps = {
  verifyToken,
  change,
  setPassword,
  setOpenAuthModal,
  closeModalGoHome,
  onAuthModalClose,
  setModalTitle,
  resetSubmittedChangeState,
  resetErrorMessage,
  resetState,
};
